import {
  wxLogin,
  get_corp_signature,
  getMediaToQiniu,
  get_agent_signature,
  deliveryWxLogin
} from '@/api/weixin.js'
import { isQYWeixin } from '@/utils/weixin'
import NProgress from 'nprogress'
import { Notify } from 'vant'
import Vue from 'vue'

const state = {
  wx_flock_id: ''
}

const mutations = {
  SET_WX_FLOCK_ID: (state, wx_flock_id) => {
    state.wx_flock_id = wx_flock_id
  }
}

const actions = {
  setWxFlockId({ commit }, wx_flock_id) {
    commit('SET_WX_FLOCK_ID', wx_flock_id)
  },
  // 企微扫码登陆
  wxLogin({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      wxLogin(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deliveryWxLogin({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      deliveryWxLogin(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取页面api授权
  get_corp_signature({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      get_corp_signature(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取页面企业接口api授权
  get_agent_signature({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      get_agent_signature(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 微信图片上传七牛
  getMediaToQiniu({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMediaToQiniu(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取微信签名信息
  getCorpSignature(temp, data) {
    return new Promise((resolve, reject) => {
      get_corp_signature(data).then(response => {
        const { corpid, corp_timestamp, corp_noncestr, corp_signature } = response.data.data
        resolve({
          appId: corpid,
          timestamp: corp_timestamp,
          nonceStr: corp_noncestr,
          signature: corp_signature
        })
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取微信签名信息
  getAgentSignature(temp, data) {
    return new Promise((resolve, reject) => {
      get_agent_signature(data).then(response => {
        const { corpid, agent_timestamp, agent_noncestr, agent_signature } = response.data.data
        resolve({
          corpid,
          timestamp: agent_timestamp,
          nonceStr: agent_noncestr,
          signature: agent_signature
        })
      }).catch(error => {
        reject(error)
      })
    })
  },
  async getCorpSignatureNet({ state, dispatch }) {
    try {
      const data = await dispatch('getCorpSignature', {
        agentid: process.env.VUE_APP_WEIXIN_AGENTID,
        url: window.location.href
      })
      return data
    } catch (error) {
      console.error(error)
      Vue.prototype.$error.message && Notify({ type: 'danger', message: error.message })
    }
  },
  async getAgentSignatureNet({ state, dispatch }) {
    try {
      const data = await dispatch('getAgentSignature', {
        agentid: process.env.VUE_APP_WEIXIN_AGENTID,
        url: window.location.href
      })
      return data
    } catch (error) {
      console.error(error)
      Vue.prototype.$error.message && Notify({ type: 'danger', message: error.message })
    }
  },
  setWxConfig({ commit }, { appId, timestamp, nonceStr, signature }) {
    return new Promise((resolve, reject) => {
      wx.config({
        beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId, // 必填，企业微信的corpID
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: [ // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
          'agentConfig',
          'openEnterpriseChat',
          'onMenuShareAppMessage',
          'updateAppMessageShareData',
          'openEnterpriseChat',
          'openExistedChatWithMsg',
          'chooseImage',
          'getLocalImgData',
          'previewImage'
        ]
      })
      wx.ready(() => {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        console.log('config:ready')
        resolve()
      })
      wx.error(res => {
        Vue.prototype.$notify({ type: 'danger', message: 'config:error' })
        console.log('config:error')
        console.error(res)
        reject(res)
      })
    })
  },
  setWxAgentConfig({ commit, state }, { corpid, timestamp, nonceStr, signature }) {
    return new Promise((resolve, reject) => {
      wx.agentConfig({
        corpid: corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid: process.env.VUE_APP_WEIXIN_AGENTID, // 必填，企业微信的[应用id](##14953#agentid)
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名，见附录1
        jsApiList: [
          'sendChatMessage',
          'selectExternalContact',
          'selectEnterpriseContact',
          'getCurExternalContact',
          'getCurExternalChat',
          'openUserProfile',
          'getCurExternalContact',
          'onMenuShareWechat',
          'shareAppMessage',
          'shareWechatMessage',
          'previewFile',
          'openEnterpriseChat',
          'openExistedChatWithMsg',
          'chooseImage',
          'getLocalImgData',
          'previewImage'
        ], // 必填
        success: function(res) {
          // 回调
          console.log('agent:success')
          resolve()
        },
        fail: function(res) {
          // Vue.prototype.$notify({ type: 'danger', message: 'agent:fail' })
          console.log('agent:fail')
          console.error(res)
          reject(res)
          if (res.errMsg.indexOf('function not exist') > -1) {
            // alert('版本过低请升级')
            Vue.prototype.$notify({ type: 'danger', message: '版本过低请升级' })
          }
        }
      })
    })
  },
  async sign({ dispatch }, success) {
    try {
      NProgress.start()
      await new Promise((resolve, reject) => setTimeout(() => { resolve() }, 300))
      const corpPromise = dispatch('getCorpSignatureNet')
      const agentPromise = isQYWeixin() ? dispatch('getAgentSignatureNet') : ''
      const corp = await corpPromise
      const agent = agentPromise ? await agentPromise : ''
      await dispatch('setWxConfig', corp)
      agent && await dispatch('setWxAgentConfig', agent)
      if (success) {
        success()
      }
    } catch (error) {
      console.error(error)
      Notify({ type: 'danger', message: error ? JSON.stringify(error) : '' })
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
